import styled from "styled-components";
import NavBar from "../../../components/NavBar";
import { Grid, ProgressBar } from "antd-mobile";
import { getInviternfo, getTeamEarning, getRewards,getLevel } from "../../../api";
import { fmoney, hideAccount } from "../../../utils/utils";
import { useState } from "react";
import { useEffect } from "react";
import useWallet from "../../../hooks/Wallet/useWallet";
import ScrollList from "./ScrollList";
import { useIntl } from "react-intl";
export default function Level() {
  const [active, setActive] = useState(1);
  const { myAccount } = useWallet();
  const [totalAmount, setTotalAmount] = useState(0);
  const [teamNum, setTeamNum] = useState(0);
  const [activity, setActivity] = useState(0);

  const [floor, setFloor] = useState(0);
  const intl = useIntl();
  useEffect(() => {
    if (myAccount) {
      init();
    }
  }, [myAccount]);

  const init = async () => {
    const inviterRes = await getInviternfo(myAccount.account); //当前等级收益
    const teamEarningRes = await getTeamEarning(myAccount.account); //每周收益
    setTotalAmount(teamEarningRes.data.amount_total);
    setTeamNum(inviterRes.data.total1);
    setActivity(inviterRes.data.activity1);
    // setFloor(inviterRes.data.floor1);
    const res_level = await getLevel(myAccount.account);
    setFloor(res_level.data);

  };

  return (
    <>
      <NavBar
        title={intl.formatMessage({
          id: "pages.level.title",
          defaultMessage: "級別",
        })}
      />
      <Content>
        <Outer>
          <Grid columns={2}>
            <Grid.Item>
              <div className="label">
                {intl.formatMessage({
                  id: "pages.level.total_amount",
                  defaultMessage: "總收益",
                })}
              </div>
              <div className="value">{fmoney(totalAmount, 0)}RT</div>
            </Grid.Item>
            <Grid.Item className="text-center">
              <img
                style={{
                  width: "9.4rem",
                  marginBottom: "1.4rem",
                  minHeight: "7.0rem",
                }}
                src={"/image/L" + floor + ".png"}
                alt=""
              />
            </Grid.Item>
          </Grid>
          <Grid columns={2}>
            <Grid.Item>
              <div className="label">
                {intl.formatMessage({
                  id: "pages.level.team_num",
                  defaultMessage: "當前團隊人數",
                })}
              </div>
              <div className="value">{teamNum}</div>
            </Grid.Item>
            <Grid.Item className="text-center">
              <div className="label">
              {intl.formatMessage({
                  id: "pages.level.week_num",
                  defaultMessage: "本周團隊活躍度",
                })}
              </div>
              <div className="progressBar">
                <ProgressBar style={{ width: "100%" }} percent={activity} />
              </div>
            </Grid.Item>
          </Grid>
        </Outer>
        <TabRow>
          <TabText active={active === 1} onClick={() => setActive(1)}>
            
          {intl.formatMessage({
                  id: "pages.level.level_profit",
                  defaultMessage: "當前等級收益",
                })}
          </TabText>
          <TabText active={active === 2} onClick={() => setActive(2)}>
          {intl.formatMessage({
                  id: "pages.level.week_profit",
                  defaultMessage: "每周收益",
                })}
          </TabText>
        </TabRow>
        {myAccount && myAccount.account ? (
          active === 2 ? (
            <ScrollList
              key={"11"}
              style={{ height: "30.0rem" }}
              headers={[
                {
                  prop: "tx_hash",
                  render: (val) => {
                    return hideAccount(val);
                  },
                },
                {
                  prop: "amount",
                  render: (val) => {
                    return (
                      <span style={{ color: "#FF5C00" }}>
                        {val.toFixed(2)} RT
                      </span>
                    );
                  },
                },
                {
                  prop: "create_time",
                  render: (val) => {
                    return val.split(" ")[0];
                  },
                },
              ]}
              pageSize="10"
              getData={async (page, done) => {
                console.log("getData");
                const res = await getTeamEarning(myAccount.account, page, 10);
                return res.data.list;
              }}
            />
          ) : (
            <ScrollList
              key={"22"}
              style={{ height: "30.0rem" }}
              headers={[
                {
                  prop: "buy_address",
                  render: (val) => {
                    return hideAccount(val);
                  },
                },
                {
                  prop: "amount",
                  render: (val) => {
                    return (
                      <span style={{ color: "#FF5C00" }}>
                        {val.toFixed(2)} RT
                      </span>
                    );
                  },
                },
                {
                  prop: "buy_time",
                  render: (val) => {
                    return val.split(" ")[0];
                  },
                },
              ]}
              pageSize="10"
              getData={async (page, done) => {
                console.log("getData");
                const res = await getRewards(myAccount.account, page, 10);
                return res.data.list;
              }}
            />
          )
        ) : null}
      </Content>
    </>
  );
}

const Outer = styled.div`
  padding: 2.5rem 4.0rem;
  border: 2px solid #000000;
  border-radius: 2.6rem;
  box-shadow: 1px 1px 1px 1px #000000;
  margin-bottom: 4.2rem;
  .label {
    font-style: normal;
    font-weight: 400;
    font-size: 1.3rem;
    line-height: 1.3rem;

    color: #969696;
    margin-bottom: 1.0rem;
  }
  .value {
    font-style: normal;
    font-weight: 600;
    font-size: 2.0rem;
    line-height: 2.0rem;

    color: #000000;
  }
  .progressBar {
    height: 2.0rem;
    display: flex;
    align-items: center;
  }
`;

const Content = styled.div`
  padding: 0 2.0rem;
`;

const TabRow = styled.div`
  display: flex;
  margin-bottom: 2.0rem;
`;

const TabText = styled.div`
  font-weight: 600;
  font-size: 1.8rem;
  line-height: 1.8rem;
  margin-right: 2.6rem;

  color: ${(props) => (props.active ? "#000000" : "#C4C4C4")};
`;
